import type { IntegrationCodesTypes } from 'modules/marketplace/lib/integrationCodes'
import { CompanyInstallations } from 'modules/marketplace/store/collections/companyInstallations'

const canSeeIntegration = (
  id: IntegrationCodesTypes,
  companyInstallation: CompanyInstallations,
  company_id?: string
) => {
  const installed = company_id
    ? companyInstallation.find({ integration_dato_id: id, company_id: company_id })
    : companyInstallation.find({ integration_dato_id: id })

  return installed
}

export default canSeeIntegration
